
function Footer(props) {
    return (
        <div className="footer">
            <h4 style={{fontFamily: 'Quintessential, cursive'}}> © 2022 <a href="https://github.com/Ampharos130" target="_blank"><img src="https://img.icons8.com/ios-glyphs/30/000000/github.png" className="githubIcon"/>Timmy Do </a>, <a href="https://github.com/TsunamiTy" target="_blank"><img src="https://img.icons8.com/ios-glyphs/30/000000/github.png" className="githubIcon"/>Tyler Hankerson</a> and <a href="https://github.com/nvthompson" target="_blank"><img src="https://img.icons8.com/ios-glyphs/30/000000/github.png" className="githubIcon"/>Nicole Thompson</a></h4>
        </div>
    )
}
export default Footer;